<template>
  <v-layout text-center wrap>
    <v-flex xs12>
      <v-img
        :src="require('../assets/logo.svg')"
        class="my-3"
        contain
        height="200"
      ></v-img>
      <br />
      <input type="file" @change="onFileSelected" />
      <button @click="onUpload">Analyse photo</button>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  name: "input",
  data() {
    return {
      selectedFile: null
    };
  },
  methods: {
    onFileSelected(event) {
      this.selectedFile = event.target.files[0];
    },
    onUpload() {
      const fd = new FormData();
      fd.append("image", this.selectedFile, this.selectedFile.name);
      axios.post("https://bird-id-api.appspot.com/upload", fd).then(res => {
        console.log(res);
      });
    }
  }
};
</script>
